import { add, addQuarters, endOfQuarter, sub, subQuarters, startOfMonth, endOfMonth } from "date-fns"
import { formatDate, convertISOToDate } from "./utils"

export default class DateRangeChanger {
  constructor(options) {

    this.id = options.parentId
    this.fromRangeEl = document.querySelector(`${this.id} .from-range`)
    this.toRangeEl = document.querySelector(`${this.id} .to-range`)
    this.dividerEl = document.querySelector(`${this.id} .divider-range`)
    this.fromRange = convertISOToDate(this.fromRangeEl.dataset.date)
    this.toRange = convertISOToDate(this.toRangeEl.dataset.date)
    this.monthFilterEl = document.querySelector(`${this.id} #month-filter`)
    this.quarterFilterEl = document.querySelector(`${this.id} #quarter-filter`)
    this.lastClickedEl = null
    this.setupEventListeners()
  }

  setupEventListeners() {
    const self = this
    $(`${self.id} .date-back`).click(function() {
      self.lastClickedEl = this
      const {newFrom, newTo} = self.previousDates()
      self.updateDateRange(newFrom, newTo)
      self.handleDateFowardButton()
    })

    $(`${self.id} .date-forward`).click(function() {
      self.lastClickedEl = this
      const { newTo, newFrom } = self.nextDates()
      self.updateDateRange(newFrom, newTo)
      self.handleDateFowardButton()
    })

    $(`${self.id} input[type="radio"][name="group-date-toggle"]`).change(function() {
      let newFrom, newTo
      self.lastClickedEl = this
      if (self.isMonthGrouping()) {
        newFrom = startOfMonth(sub(self.toRange, {months: 2}))
        newTo = self.toRange
      } else if (self.isQuarterGrouping()) {
        newTo = endOfQuarter(self.toRange)
        newFrom = startOfMonth(sub(newTo, {months: 11}))
      }
      
      self.updateDateRange(newFrom, newTo)
    })
  }

  handleDateFowardButton() {
    const canGoFoward = this.canGoForward()
    const forwardButton = document.querySelector(`${this.id} .date-forward`)
    if (canGoFoward) {
      forwardButton.removeAttribute("disabled")
    } else {
      forwardButton.setAttribute("disabled", true)
    }
  }

  previousDates() {
    let newFrom, newTo
    if (this.isMonthGrouping()) {
      newFrom = sub(this.fromRange, {months: 1})
      newTo = sub(this.toRange, {months: 1})
    } else if (this.isQuarterGrouping()) {
      newFrom = subQuarters(this.fromRange, 1)
      newTo = subQuarters(this.toRange, 1)
    }
    return { newTo, newFrom }
  }

  nextDates() {
    let newFrom, newTo
    if (this.isMonthGrouping()) {
      newFrom = add(this.fromRange, {months: 1})
      newTo = add(this.toRange, {months: 1})
    } else if (this.isQuarterGrouping()) {
      newFrom = addQuarters(this.fromRange, 1)
      newTo = addQuarters(this.toRange, 1)
    }
    return { newTo, newFrom }
  }

  updateDateRange(newFrom, newTo) {
    const self = this

    self.fromRangeEl.classList.remove('show')
    self.toRangeEl.classList.remove('show')
    self.dividerEl.classList.remove('show')

    if (newFrom && newTo) {
      self.fromRange = startOfMonth(newFrom)
      self.toRange = endOfMonth(newTo)
      self.fromRangeEl.dataset.date = formatDate(newFrom, "yyyy-MM-dd")
      self.toRangeEl.dataset.date = formatDate(newTo, "yyyy-MM-dd")
      const {fromDisplay, toDisplay} = this.getDisplayDates()
      self.emitChangeEvent()
      setTimeout(() => {
        self.fromRangeEl.innerHTML = fromDisplay
        self.toRangeEl.innerHTML = toDisplay
        this.fromRangeEl.classList.add('show')
        this.toRangeEl.classList.add('show')
        this.dividerEl.classList.add('show')
      }, 400)
    }
  }

  getDisplayDates() {
    return {
      fromDisplay: formatDate(this.fromRange, this.getDateFormating()),
      toDisplay: formatDate(this.toRange, this.getDateFormating()),
    }
  }

  canGoForward() {
    const { newTo } = this.nextDates()
    if ( this.isMonthGrouping()) {
      return endOfMonth(new Date()) >= newTo
    } else {
      return endOfQuarter(new Date()) >= newTo
    }
  }

  isMonthGrouping() {
    return this.monthFilterEl.checked
  }

  isQuarterGrouping() {
    return this.quarterFilterEl.checked
  }

  getDateFormating() {
    if (this.isMonthGrouping()) return 'MMM yyyy'
    if (this.isQuarterGrouping()) return 'QQQ yyyy'
  }

  getGrouping() {
    if (this.isMonthGrouping()) return 'month'
    if (this.isQuarterGrouping()) return 'quarter'
  }

  getValues() {
    return { from_range: formatDate(this.fromRange, "yyyy-MM-dd"), to_range: formatDate(this.toRange, "yyyy-MM-dd"), group: this.getGrouping(), ...this.getDisplayDates()}
  }

  emitChangeEvent() {
    this.lastClickedEl.dispatchEvent(new CustomEvent('dateRangeChanged', { detail: this.getValues() }))
  }


}
